import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Components */
import { Icon } from "../../components"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* Moment */
import moment from "moment"
import "moment/locale/ru"

/* DatePicker */
import DatePicker, { registerLocale } from "react-datepicker"
import ru from "date-fns/locale/ru"

/* REST API */
import { time } from "../../api/Booking"

/* Widgets */
import { toast, pickTime } from "../common"

registerLocale("ru", ru)
moment.locale("ru")
Modal.setAppElement("#root")


/* The lengths of a visit the form offers, the rest is written by hand */
const DURATIONS = [15, 20, 30, 45, 60, 90, 120]


/* Widget Time Modal — the visit is moved to another day and hour, and the length of it
   is changed by the same door. It is opened by the reference: this._time.current.open(booking) */
class TimeModal extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            saving: false,

            id: 0,
            date: new Date(),
            hour: "10:00",
            duration: "30",
            notify: true
        }
    }

    /* Open the form on the time the visit stands at now */
    open = booking => {

        const reserved = moment(booking.reservedTime)

        this.setState({
            visible: true,
            saving: false,
            id: booking.id,
            date: reserved.toDate(),
            hour: reserved.format("HH:mm"),
            duration: booking.sessionTime ? `${parseInt(booking.sessionTime)}` : "30",
            notify: true
        })
    }

    /* Close the form */
    close = () => {

        /* The request is already on its way */
        if (this.state.saving) {
            return
        }

        this.setState({ visible: false })
    }

    /* The hour is chosen in the window of the panel and not in the one the browser draws */
    choose = () => {

        pickTime({ title: "Время записи", value: this.state.hour }).then(value => {

            if (value) {
                this.setState({ hour: value })
            }
        })
    }

    /* Move the visit */
    save = () => {

        /* Fields */
        const { saving, id, date, hour, duration, notify } = this.state
        const { onSaved } = this.props

        /* The request is already on its way */
        if (saving) {
            return
        }

        /* The length of the visit is written in minutes */
        const session = parseInt(duration)

        if (isNaN(session) || session < 5) {
            toast.error("Укажите длительность записи")
            return
        }

        this.setState({ saving: true })

        time({ id, reservedTime: `${moment(date).format("YYYY-MM-DD")} ${hour}:00`, sessionTime: session, notify }).then(response => {

            if (response && response.status === 200) {

                this.setState({ visible: false, saving: false })

                toast.success("Время записи изменено")

                if (onSaved) {
                    onSaved()
                }
            }
            else {
                this.setState({ saving: false })
                toast.error("Не удалось изменить время записи")
            }
        }).catch(() => {
            this.setState({ saving: false })
            toast.error("Не удалось изменить время записи")
        })
    }

    render = () => {

        /* Fields */
        const { visible, saving, date, hour, duration, notify } = this.state

        const ends = moment(`${moment(date).format("YYYY-MM-DD")} ${hour}`, "YYYY-MM-DD HH:mm").add(parseInt(duration) ? parseInt(duration) : 0, "minutes")

        return (
            <Modal
                isOpen={visible}
                onRequestClose={this.close}
                className="booking-form-modal"
                overlayClassName="booking-form-overlay"
                closeTimeoutMS={200}
            >

                <div className="booking-form-header">
                    <h2>Изменить время</h2>
                    <div onClick={this.close} className="booking-form-close">
                        <Icon name="close" size={11} width={2.2} />
                    </div>
                </div>

                <div className="booking-form-body">

                    <div className="booking-form-label">Дата записи</div>

                    <div className="booking-form-calendar">
                        <DatePicker
                            inline
                            locale="ru"
                            selected={date}
                            onChange={value => this.setState({ date: value })}
                        />
                    </div>

                    <div className="booking-form-label">Время начала</div>

                    <div onClick={this.choose} className="booking-form-time">
                        <Icon name="booking" size={18} />
                        <span>{hour}</span>
                        <em>окончание в {ends.isValid() ? ends.format("HH:mm") : "--:--"}</em>
                    </div>

                    <div className="booking-form-label">Длительность, мин</div>

                    <div className="booking-form-chips">
                        {DURATIONS.map(item =>
                            <div
                                key={`${item}`}
                                onClick={() => this.setState({ duration: `${item}` })}
                                className={`booking-form-chip ${`${duration}` === `${item}` ? "active" : ""}`}
                            >
                                {item}
                            </div>
                        )}
                    </div>

                    <input
                        className="booking-form-input"
                        placeholder="Своя длительность"
                        value={duration}
                        onChange={event => this.setState({ duration: event.target.value.replace(/\D/g, "") })}
                    />

                    <div onClick={() => this.setState({ notify: !notify })} className={`booking-form-check ${notify ? "active" : ""}`}>
                        <i />
                        <span>Сообщить клиенту о переносе</span>
                    </div>

                </div>

                <div className="booking-form-footer">
                    <div onClick={this.close} className="booking-form-button light">Отмена</div>
                    <div onClick={this.save} className={`booking-form-button ${saving ? "disabled" : ""}`}>
                        {saving ? <LoadingOutlined /> : "Сохранить"}
                    </div>
                </div>

            </Modal>
        )
    }
}

export default TimeModal
